import { komaMin, komaDenom, marginFromMin, marginToMin, koma24 } from '@/utility/consts/ComProps';
import { toLocalDate } from '@/utility/date';

export function komaToText(koma: number): string {
  const komaHH = ('00' + (Math.floor(koma / komaDenom) % 24)).slice(-2);
  const komaMM = ('00' + komaMin * (koma % komaDenom)).slice(-2);
  return `${komaHH}:${komaMM}`;
}

export function textToKoma(time: string): number | undefined {
  const st = time.split(':');
  const res = st.length === 2 ? 4 * Number(st[0]) + Math.floor(Number(st[1]) / 15) : undefined;
  return res;
}

export function komaToText48(koma: number): string {
  const komaHH = ('00' + (Math.floor(koma / komaDenom) % 48)).slice(-2);
  const komaMM = ('00' + komaMin * (koma % komaDenom)).slice(-2);
  return `${komaHH}:${komaMM}`;
}

//  fromPunchTimeから調整後の時刻を求め、最大の選べる時刻を取得する
export function getSelectableOutPunchTime(punchTimeFrom: Date): Date {
  const fromDt = toResultInPunchTime(punchTimeFrom);
  const toDt = new Date(fromDt);
  toDt.setHours(toDt.getHours() + 24);
  toDt.setMinutes(toDt.getMinutes() - marginToMin);
  return toDt;
}

//  調整後の打刻時刻を取得 In
export function toResultInPunchTime(inPunchTime: Date): Date {
  const dt = new Date(inPunchTime);
  dt.setMinutes(dt.getMinutes() + (komaMin - marginFromMin));
  dt.setMinutes(Math.floor(dt.getMinutes() / komaMin) * komaMin); //< 二回に別ける
  dt.setSeconds(0);
  return dt;
}

//  時刻からコマへ変換(切り捨て)
export function toKoma(date: Date): number {
  return Math.floor((date.getHours() * 60 + date.getMinutes()) / komaMin);
}

//  現在時刻から実績と予定が切り替わるコマ時刻へ変換
export function nowToCutDate(nowDt: Date): Date {
  const dt = new Date(nowDt.getFullYear(), nowDt.getMonth(), nowDt.getDate(), 0, 0, 0);
  dt.setMinutes(dt.getMinutes() + (toKoma(nowDt) + 1) * komaMin);
  return dt;
}

//  コマからdateへ
export function komaToDate(koma: number, date: Date): Date {
  const dt = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
  dt.setMinutes(dt.getMinutes() + koma * komaMin);
  return dt;
}

//  X3のコマインデックスに変換
export function komaDateToX3Index(fromKomaDt: Date, toKomaDt: Date, targetDate: Date): number[] {
  const maxLen = 3 * koma24;

  const fromDate = toLocalDate(fromKomaDt);
  const fromStIndex = fromDate.getTime() === targetDate.getTime() ? 1 : fromDate.getTime() <= targetDate.getTime() ? 0 : 2;
  const fromIndex = fromStIndex * koma24 + (fromKomaDt.getTime() - fromDate.getTime()) / (1000 * 60) / komaMin; // 分に変換

  const toDate = toLocalDate(toKomaDt);
  const toStIndex = toDate.getTime() === targetDate.getTime() ? 1 : toDate.getTime() <= targetDate.getTime() ? 0 : 2;
  const toIndex = toStIndex * koma24 + (toKomaDt.getTime() - toDate.getTime()) / (1000 * 60) / komaMin; // 分に変換

  return [fromIndex < maxLen ? fromIndex : maxLen - 1, toIndex < maxLen ? toIndex : maxLen - 1];
}
